// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/DeletedItemSelection.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file Enumerations/DeletedItemSelection.proto.
 */
export const file_Enumerations_DeletedItemSelection: GenFile = /*@__PURE__*/
  fileDesc("CidFbnVtZXJhdGlvbnMvRGVsZXRlZEl0ZW1TZWxlY3Rpb24ucHJvdG8SGnRpbWVfdHJhY2tpbmcuZW51bWVyYXRpb25zKogBChREZWxldGVkSXRlbVNlbGVjdGlvbhImCiJERUxFVEVEX0lURU1fU0VMRUNUSU9OX05PUk1BTF9PTkxZEAASJwojREVMRVRFRF9JVEVNX1NFTEVDVElPTl9ERUxFVEVEX09OTFkQARIfChtERUxFVEVEX0lURU1fU0VMRUNUSU9OX0JPVEgQAkIoqgIlTW9naS5UaW1lVHJhY2tpbmcuQ29tbW9uLkVudW1lcmF0aW9uc2IGcHJvdG8z");

/**
 * Determines whether to include deleted items returned from gRPC calls.
 *
 * @generated from enum time_tracking.enumerations.DeletedItemSelection
 */
export enum DeletedItemSelection {
  /**
   * Only return items that have not been deleted.
   *
   * @generated from enum value: DELETED_ITEM_SELECTION_NORMAL_ONLY = 0;
   */
  NORMAL_ONLY = 0,

  /**
   * Only return items that have been deleted.
   *
   * @generated from enum value: DELETED_ITEM_SELECTION_DELETED_ONLY = 1;
   */
  DELETED_ONLY = 1,

  /**
   * Return all items regardless of whether they have been deleted or not.
   *
   * @generated from enum value: DELETED_ITEM_SELECTION_BOTH = 2;
   */
  BOTH = 2,
}

/**
 * Describes the enum time_tracking.enumerations.DeletedItemSelection.
 */
export const DeletedItemSelectionSchema: GenEnum<DeletedItemSelection> = /*@__PURE__*/
  enumDesc(file_Enumerations_DeletedItemSelection, 0);

